import ViewExportContainer from '../ViewExport/ViewExportContainer';

import { formatDate } from '../../utils';
import { getAnnouncementCriteria } from './utils';

const getTableData = (data, columns) => {
  const headers = columns
    .filter(({ id }) => id !== 'actions')
    .map(({ Header }) => Header);
  const rows = [];
  data.forEach((entry) => {
    const { createdAt, subject, message, sent } = entry;
    rows.push([
      formatDate(createdAt),
      subject,
      message,
      getAnnouncementCriteria(entry),
      sent ? 'true' : 'false',
    ]);
  });
  return { headers, rows };
};

const AnnouncementsExport = (props) => (
  <ViewExportContainer {...props} getTableData={getTableData} />
);

export default AnnouncementsExport;
